<template>
  <div class="md-layout">
    <div class="md-layout-item">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-green my-row">
          <div class="card-icon">
            <md-icon>sports_esports</md-icon>
          </div>
          <h4 class="title">Доступные аппараты</h4>
        </md-card-header>
        <div class="my-row">
          <md-button
            class="my-md-button md-success"
            @click.native="
              sn_for_scroll = '';
              load();
            "
          >
            <span class="material-icons"> refresh </span>
            Обновить
          </md-button>
        </div>
        <div class="my-row">
          <md-field class="filter-field">
            <label>Фильтр по SN</label>
            <md-input v-model="filterSn" inputmode="numeric" pattern="[0-9]*" />
          </md-field>

          <md-button
            class="md-button md-warning reset-btn"
            @click="resetFilter"
          >
            Сброс
          </md-button>
        </div>

        <md-card-content v-if="isApvs">
          <div>{{ loadingMessage }}</div>
        </md-card-content>
        <md-card-content v-else>
          <apv-card
            v-for="item in filteredModel"
            :key="item.sn"
            :item="item"
            :filterSn="filterSn"
            :id="'apv-' + item.sn"
            :devicesModel="devicesModel"
            :messagesModel="messagesModel"
            :errorsModel="errorsModel"
          ></apv-card>
        </md-card-content>

        <div class="my-row">
          <md-button
            class="my-md-button md-success"
            @click.native="
              sn_for_scroll = '';
              load();
            "
          >
            <span class="material-icons"> refresh </span>
            Обновить
          </md-button>
        </div>
      </md-card>
    </div>
  </div>
</template>

<script>
import ApvCard from "../components/EngMessages/ApvCard.vue";
// import { Pagination } from "@/components";

export default {
  // components: { MessCard, Pagination },
  components: { ApvCard },
  computed: {
    isApvs() {
      if (this.filteredModel.length == 0) {
        return true;
      } else {
        return false;
      }
    },
    filteredModel() {
      const q = this.filterSn.trim().toLowerCase();
      if (!q) return this.model;
      return this.model.filter((item) =>
        String(item.sn).toLowerCase().includes(q)
      );
    },
  },
  data() {
    return {
      loadingMessage: "Загрузка данных",
      model: [],
      devicesModel: {},
      errorsModel: {},
      messagesModel: {},
      sn_for_scroll: "",
      filterSn: "",
    };
  },
  methods: {
    resetFilter() {
      this.filterSn = "";
    },
    load() {
      this.ajax.getEngApvs(
        this,
        {},
        (r) => {
          if (r.status == "ok") {
            if (r.data.length == 0) {
              this.loadingMessage = "Нет аппаратов";
            }
            this.model = r.data;
            this.errorsModel = r.errorsModel;
            this.devicesModel = r.devicesModel;
            this.messagesModel = r.messagesModel;

            // для прокрутки на нужную карточку
            this.$nextTick(() => {
              if (this.sn_for_scroll) {
                const el = document.getElementById(`apv-${this.sn_for_scroll}`);
                if (el) {
                  // const rect = el.getBoundingClientRect();
                  el.scrollIntoView({ block: "center", inline: "nearest" }); // без behavior
                }
              }
            });
          } else {
            this.showErrorNotify(r);
          }
        },
        (err) => {
          //console.log(err);
        }
      );
    },
  },
  created() {
    this.sn_for_scroll = this.$route.query.sn || "";
    this.filterSn = this.$route.query.filterSn || "";
    this.load();
  },
  watch: {},
};
</script>

<style lang="css" scoped>
.md-tabs {
  margin-bottom: 24px;
}

.material-icons {
  margin-right: 15px;
}

.my-md-button {
  width: 100%;
  height: 41px;
  margin-top: 5px;
}

.my-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  margin-left: 20px;
  margin-right: 20px;
}

.filter-field {
  flex: 1;
  margin-top: 15px;
  margin-right: 15px;
}

.reset-btn {
  white-space: nowrap;
}
</style>
